var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play-button-icon",
    transform: "translate(1.75 1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5251 49.0503C38.07 49.0503 49.0503 38.07 49.0503 24.5251C49.0503 10.9803 38.07 0 24.5251 0C10.9803 0 0 10.9803 0 24.5251C0 38.07 10.9803 49.0503 24.5251 49.0503Z",
    id: "Oval",
    fill: "none",
    stroke: "#1DA1F2",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0823 5.03027e-16L24.1646 18.1234L-1.67676e-16 18.1234L12.0823 5.03027e-16Z",
    transform: "matrix(-4.371139E-08 1 -1 -4.371139E-08 35.87451 12.44281)",
    id: "Triangle",
    fill: "#1DA1F2",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonIcon);
export default __webpack_public_path__ + "static/media/play-button-icon.b1eafab44e6723ab1b0c31b56abab846.svg";
export { ForwardRef as ReactComponent };